import Vue from 'vue';
import App from './App';
import router from './router';
//引入全局css文件
// import './assets/css/global.css';
import Global from "./assets/css/global.css";
import axios from 'axios';
// 手动按需引入有赞组件
import {
  NavBar,
  Pagination,
  Empty,
  Swipe,
  SwipeItem,
  Badge,
  Icon,
  Tabbar,
  TabbarItem,
  ActionSheet,
  Popup,
  Cell,
  CellGroup,
  Calendar,
  Button,
  Toast,
  Progress,
  Lazyload,
  Stepper,
  Uploader,
  Dialog,
  List,
  ShareSheet,
  Switch,
  Area,
  Collapse,
  CollapseItem,
  Picker,
  Form,
  Field,
  DatetimePicker,
  RadioGroup,
  Radio,
  Cascader,
  Search,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
} from 'vant';
import { Image as VanImage } from 'vant';
import 'vant/lib/index.css';
// 引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
Vue.use(ElementUI);
import qs from 'qs';
import scroll from 'vue-seamless-scroll';

// 移动端调试工具
// import Vconsole from 'vconsole'
// let vconsole = new Vconsole()
// Vue.use(vconsole)

// 有赞组件注册
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Badge);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(ActionSheet);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Calendar);
Vue.use(Toast);
Vue.use(Progress);
Vue.use(Lazyload);
Vue.use(Stepper);
Vue.use(Uploader);
Vue.use(Dialog);
Vue.use(List);
Vue.use(ShareSheet);
Vue.use(Switch);
Vue.use(Area);
Vue.use(Collapse);
Vue.use(Picker);
Vue.use(CollapseItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(DatetimePicker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Cascader);
Vue.use(Search);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(TreeSelect);
Vue.use(Button);
Vue.use(Empty);
Vue.use(Pagination);
Vue.use(VanImage);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(scroll);
Vue.use(Global);

// 配全局属性配置，在任意组件内可以使用this.$qs获取qs对象
Vue.prototype.$qs = qs;

// 配置根目录
axios.defaults.baseURL = 'https://gcxy.alumni-resource.com/xyh';
// axios.defaults.baseURL = 'http://127.0.0.1:8089/xyh';

// 统一携带登录态token（后端 AuthenticationInterceptor 按token鉴权）
axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// 登录态失效统一回登录页（保留 openid/phone，登录页会静默换回新的token）
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      window.localStorage.removeItem('token');
      if ((window.location.hash || '').indexOf('#/login') !== 0) {
        window.location.hash = '#/login';
      }
    }
    return Promise.reject(error);
  }
);
window.localStorage.setItem('ActivityqrcodelUrl', 'https://gcxy.alumni-resource.com/#/Activityqrcode');
window.localStorage.setItem('WelfarelUrl', 'https://gcxy.alumni-resource.com/#/Welfareqrcode');

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js